"use client";

import { useState, useEffect, useMemo } from "react";
import NoDataFound from "../shared/NoDataFound.js";
import React from "react";
import {
  ArrowLeft,
  Save,
  Target,
  Settings,
  Plus,
  Minus,
  Users,
  User,
  Info,
  ChevronRight,
  ChevronLeft,
  Search,
  Filter,
  Pencil,
  Loader2,
  Check,
  X,
} from "lucide-react";
import { useTranslation } from "react-i18next";
import Modal from "../layout/Modal";
import "./TeamCreatePage.css";
import { handleApiError as baseHandleApiError } from "../shared/util";
import SubscriptionExpiredModal from "../dashboard/SubscriptionExpiredModal";
import CustomTooltip from "../shared/CustomTooltip";
import { useNavigate, useLocation } from "react-router-dom";
import { getDepartmentsListApi } from "../../services/settingsService";
import { getAllPeopleApi } from "../../services/peopleService";
import {
  createTeamApi,
  getSkillsByTeamDescApi,
  getTeamByIdApi,
  updateTeamApi,
  getTeamLeadNamesApi,
} from "../../services/teamsService";
import ViewMoreModal from "../shared/ViewMoreModal";

// Generic Modal for displaying skill lists
const SkillListModal = ({ title, skills, type, onClose, onRemoveSkill }) => {
  return (
    <div className="job-skills-modal-overlay">
      <div className="job-skills-modal-content unique-job-skills-modal">
        <div className="job-skills-modal-header">
          <h3>{title}</h3>
          <button onClick={onClose} className="job-skills-modal-close-btn">
            <X size={20} />
          </button>
        </div>
        <div className="job-skills-modal-grid">
          {type === "soft"
            ? skills.map((skill, index) => (
                <div key={index} className="soft-skill-item-modal">
                  <span className="soft-skill-name">{skill.name}:</span>
                  {skill.value !== undefined && (
                    <span className="soft-skill-value">{skill.value}</span>
                  )}
                </div>
              ))
            : skills.map((skill, index) => (
                <div key={index} className="job-skill-card">
                  <span>{skill}</span>
                  {onRemoveSkill && (
                    <button
                      onClick={() => onRemoveSkill(skill)}
                      className="job-skill-remove-btn"
                    >
                      <X size={14} />
                    </button>
                  )}
                </div>
              ))}
        </div>
      </div>
    </div>
  );
};

const TeamCreatePage = ({ onSave }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState({
    show: false,
    type: "",
    title: "",
    message: "",
  });
  const [activeTab, setActiveTab] = useState("basic");
  const [searchTerm, setSearchTerm] = useState("");
  const [filterDepartment, setFilterDepartment] = useState("");
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [showDuplicateOptions, setShowDuplicateOptions] = useState(false);
  const [selectedTeamToDuplicate, setSelectedTeamToDuplicate] = useState(null);
  const [duplicateSearchTerm, setDuplicateSearchTerm] = useState("");
  const [duplicateFilterDepartment, setDuplicateFilterDepartment] =
    useState("All");

  // New states for soft and job skills editing
  const [editingSoftSkill, setEditingSoftSkill] = useState(null);
  const [softSkillValues, setSoftSkillValues] = useState({});
  const [tempSoftSkills, setTempSoftSkills] = useState({});
  // near other state
  const [removedJobSkills, setRemovedJobSkills] = useState([]); // lowercased labels

  // editable list (user adds/removes here)
  const [tempJobSkills, setTempJobSkills] = useState([]);

  // latest suggestions from API (don’t edit this directly)
  const [apiJobSkills, setApiJobSkills] = useState([]);

  // Modals for skill sections
  const [showSoftSkillListModal, setShowSoftSkillListModal] = useState({
    visible: false,
    title: "",
    skills: [],
    type: "soft",
  });
  const [showJobSkillListModal, setShowJobSkillListModal] = useState({
    visible: false,
    title: "",
    skills: [],
    type: "job",
    removable: false,
  });

  const location = useLocation();
  const duplicateFromTeam = location.state?.duplicateFrom;

  const [formData, setFormData] = useState({
    name: "",
    department: "",
    lead: {
      userId: "",
      name: "",
    },
    description: "",
    location: "",
    workStyle: "",
    budget: "",
    openPositions: 0,
    project: "",
    projects: [],

    openPositionTypes: [],
    skills: [],
    neededSkills: [],
    teamCulture: "",
    softSkills: { benchmarkSkills: {}, skillsFound: [], skillsMissing: [] },
    hardSkills: { skillsRequired: [], skillsFound: [], skillsMissing: [] },
  });
  // merged view for rendering (prefer user override -> then API)
  const merged = {
    ...(formData.softSkills?.benchmarkSkills || {}),
    ...tempSoftSkills,
    ...softSkillValues,
  };
  const [newSkill, setNewSkill] = useState("");
  const [newNeededSkill, setNewNeededSkill] = useState("");
  const [newPositionType, setNewPositionType] = useState("");

  const [showSubscriptionExpired, setShowSubscriptionExpired] = useState(false);
  const [subscriptionMessage, setSubscriptionMessage] = useState("");

  const handleSubscriptionRedirect = () =>
    new Promise((resolve) => {
      setTimeout(() => {
        navigate("/pricing");
        resolve();
      }, 100);
    });

  const handleApiError = (error, options) => {
    if (error?.response?.status === 403) {
      setSubscriptionMessage(
        error?.response?.data?.message || t("subscription.upgradePlanMessage"),
      );
      setShowSubscriptionExpired(true);
      return;
    }
    return baseHandleApiError(error, options);
  };

  useEffect(() => {
    // Fetch departments for dropdown on initial load
    getDepartmentsDropDownApiHandler();
    // getManagerDropdownApiHandler();
  }, []);

  const [teamLead, setTeamLead] = useState([]);
  // const getManagerDropdownApiHandler = async () => {
  //   try {
  //     const response = await getAllPeopleApi();
  //     setTeamLead(
  //       response.data.map((person) => ({
  //         name: person.name,
  //         id: person.userId,
  //       }))
  //     );
  //   } catch (error) {
  //     handleApiError(error, {
  //       showModal: false,
  //     });
  //   }
  // };
  const [isTeamLeadLoading, setIsTeamLeadLoading] = useState(false);
  const debouncedRef = React.useRef(null);
  const onTeamNameChange = (e) => {
    setFormData((prev) => ({ ...prev, name: e.target.value }));
    clearTimeout(debouncedRef.current);
    debouncedRef.current = setTimeout(() => {
      getTeamLeadNamesApiHandler(e);
    }, 1000);
  };

  const getTeamLeadNamesApiHandler = async (e) => {
    console.log("Fetching team lead names...", e);
    try {
      setIsTeamLeadLoading(true);
      let obj = {
        teamName: e.target.value || "",
      };
      const response = await getTeamLeadNamesApi(obj);
      setTeamLead(
        response.data.map((person) => ({
          name: person.name,
          id: person._id,
        })),
      );
    } catch (error) {
      handleApiError(error, {
        showModal: true,
        type: "error",
        title: error.message,
        showButton: false,
      });
    } finally {
      setIsTeamLeadLoading(false);
    }
  };

  const [vmOpen, setVmOpen] = React.useState(false);
  const [vmTitle, setVmTitle] = React.useState("");
  const [vmSkills, setVmSkills] = React.useState([]);

  const openViewMore = (title, skills) => {
    setVmTitle(title);
    setVmSkills(skills || []);
    setVmOpen(true);
  };

  // PAGINATION LOGIC

  const [currentPage, setCurrentPage] = useState(1);
  const [employees, setEmployees] = useState([]);

  const [employeesLength, setEmployeesLength] = useState(null);
  const [itemsPerPage] = useState(10); // 20 items per page // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const totalPages = Math.ceil(employeesLength / itemsPerPage);
  useEffect(() => {
    setEmployeesLength(employees.length || null);
    // if the list shrinks (e.g., after filter), clamp the page
    const newTotalPages = Math.max(
      1,
      Math.ceil(employees.length / itemsPerPage),
    );
    setCurrentPage((p) => Math.min(p, newTotalPages));
  }, [employees, itemsPerPage]);
  // slice for the current page
  const paginatedEmployees = useMemo(
    () => employees.slice(indexOfFirstItem, indexOfLastItem),
    [employees, indexOfFirstItem, indexOfLastItem],
  );

  // useEffect(() => {
  //   getEmployeesDropdownApiHandler();
  // }, [searchTerm, filterDepartment, currentPage]);

  // const getEmployeesDropdownApiHandler = async () => {
  //   try {
  //     const obj = {
  //       pageNo: currentPage,
  //       pageSize: itemsPerPage,
  //       searchFilter: searchTerm,
  //       department: filterDepartment === "All" ? "" : filterDepartment,
  //     };
  //     const response = await getAllPeopleApi(obj);
  //     setEmployees(response.data);
  //     setEmployeesLength(response.totalCount);
  //   } catch (error) {
  //     handleApiError(error, {
  //       showModal: false,
  //     });
  //   }
  // };

  // GET TEAM BY ID
  const [paramId, setParamId] = useState(null);
  const [allEmployees, setAllEmployees] = useState([]);
  const getTeamByIdApiHandler = async (id) => {
    try {
      const response = await getTeamByIdApi(id);
      if (response.code === 200) {
        setActiveTab("members");
        setEmployees(response.data.matches || []);
        setAllEmployees(response.data.matches || []);
        setEmployeesLength(response.data.matches.length || null);
        setParamId(response.data._id);
      }
      console.log("Fetched Team Data:", response);
    } catch (error) {
      console.error("Error fetching team data:", error);
      handleApiError(error, {
        showModal: false,
      });
    }
  };
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handlePrevPage = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const handleNextPage = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };
  const [departments, setDepartments] = useState([]);
  // GET DEPARTMENTS DROPDOWN DATA
  const getDepartmentsDropDownApiHandler = async () => {
    try {
      const response = await getDepartmentsListApi();
      setDepartments(response.data || []);
    } catch (error) {
      console.error("Error fetching departments:", error);
      handleApiError(error, {
        showModal: false,
      });
    }
  };
  // On-site, Remote, Hybrid, Flexible,
  const workStyles = ["Remote", "Hybrid", "On-site", "Flexible"];

  // Common position types for dropdown
  const commonPositionTypes = [
    "Senior Frontend Developer",
    "Junior Frontend Developer",
    "Backend Developer",
    "Full Stack Developer",
    "UX Designer",
    "UI Designer",
    "Product Manager",
    "Data Scientist",
    "DevOps Engineer",
    "QA Engineer",
    "Technical Lead",
    "Engineering Manager",
    "Marketing Specialist",
    "Sales Representative",
    "Business Analyst",
    "Project Manager",
  ];

  const navigate = useNavigate();
  const onNavigate = (page) => {
    navigate(page);
  };

  // GET SKILLS BY DESCRIPTION AND CULTURE
  // const getSkillsByTeamDescApiHandler = async (teamData) => {
  //   setIsNextLoading(true);
  //   console.log("Fetching skills for team description and culture:", teamData);
  //   try {
  //     let obj = {
  //       description: teamData.description,
  //       teamCulture: teamData.teamCulture,
  //     };
  //     const response = await getSkillsByTeamDescApi(obj);

  //     formData.softSkills.skillsFound = response.data.softSkillsRequired || [];

  //     formData.neededSkills = response.data.jobSkillsRequired || [];
  //     console.log(
  //       "Skills fetched successfully:",
  //       formData.softSkills.skillsFound
  //     );
  //     if (response.code == 200) {
  //       setActiveTab("skills");
  //     }
  //     // Handle the response as needed
  //   } catch (error) {
  //     handleApiError(error, {
  //       showModal: false,
  //     });
  //   } finally {
  //     setIsNextLoading(false);
  //   }
  // };

  const getSkillsByTeamDescApiHandler = async (teamData) => {
    setIsNextLoading(true);
    try {
      const response = await getSkillsByTeamDescApi({
        description: teamData.description,
        teamCulture: teamData.teamCulture,
      });

      const raw = response?.data?.softSkillsRequired || {};
      const fetched = Object.fromEntries(
        Object.entries(raw).map(([name, value]) => [
          String(name),
          Number(value ?? 0),
        ]),
      );

      // Top-up baseline without clobbering user-edited fields
      setTempSoftSkills((prev) => {
        const next = { ...prev };
        for (const [name, value] of Object.entries(fetched)) {
          if (!(name in softSkillValues)) next[name] = value;
        }
        return next;
      });

      // Keep formData in sync (and SET skillsFound so your UI gate passes)
      // setFormData((fd) => ({
      //   ...fd,
      //   softSkills: {
      //     ...fd.softSkills,
      //     benchmarkSkills: fetched, // raw API baseline
      //     skillsFound: fetched, // <-- important: so the UI gate isn't empty
      //   },
      //   neededSkills: response?.data?.jobSkillsRequired ?? [],
      //   tempJobSkills: response?.data?.jobSkillsRequired ?? [],
      // }));
      const apiSkills = (response?.data?.jobSkillsRequired ?? [])
        .map((s) => String(s || "").trim())
        .filter(Boolean);
      const removed = new Set(removedJobSkills);
      setApiJobSkills(apiSkills);
      // formData.neededSkills;
      if (response?.code === 200) setActiveTab("skills");
    } catch (err) {
      handleApiError(err, { showModal: true });
    } finally {
      setIsNextLoading(false);
    }
  };
  // Handle duplication from team detail page
  useEffect(() => {
    if (duplicateFromTeam) {
      handleDuplicateTeam(duplicateFromTeam);
    }
  }, [duplicateFromTeam]);

  const handleDuplicateTeam = (team) => {
    setFormData({
      name: `${team.name} - Copy`,
      department: team.department,
      lead: team.lead,
      description: team.description,
      location: team.location,
      workStyle: team.workStyle,
      budget: team.budget,
      openPositions: team.openPositions,
      openPositionTypes: team.openPositionTypes || [],
      skills: [...team.skills],
      neededSkills: [...team.neededSkills],
      teamCulture: team.teamCulture,
      softSkills: team.softSkills || {
        benchmarkSkills: {},
        skillsFound: [],
        skillsMissing: [],
      },
      hardSkills: team.hardSkills || {
        skillsRequired: [],
        skillsFound: [],
        skillsMissing: [],
      },
    });

    setShowModal({
      show: true,
      type: "success",
      title: t("teamCreatePage.teamDuplicated"),
      message: t("teamCreatePage.teamDuplicatedMessage", {
        teamName: team.name,
      }),
    });

    setShowDuplicateOptions(false);
    setSelectedTeamToDuplicate(null);
  };

  // const filteredEmployees = employees.filter((employee) => {
  //   const matchesSearch =
  //     employee.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //     employee.role.toLowerCase().includes(searchTerm.toLowerCase()) ||
  //     employee.skills.some((skill) =>
  //       skill.toLowerCase().includes(searchTerm.toLowerCase())
  //     );

  //   const matchesDepartment =
  //     filterDepartment === "All" || employee.department === filterDepartment;

  //   return (
  //     matchesSearch &&
  //     matchesDepartment &&
  //     !selectedMembers.find((member) => member.id === employee.id)
  //   );
  // });

  // helper
  const safeIncludes = (val = "", term = "") =>
    String(val).toLowerCase().includes(term);

  // re-filter whenever inputs change
  useEffect(() => {
    const term = searchTerm.trim().toLowerCase();
    const dept = (filterDepartment || "").trim(); // "" means all

    const filtered = allEmployees.filter((e) => {
      const matchesSearch =
        !term ||
        safeIncludes(e.name, term) ||
        safeIncludes(e.designation, term) || // ← use designation (what you render)
        safeIncludes(e.role, term) ||
        (Array.isArray(e.skills) &&
          e.skills.some((s) => safeIncludes(s, term)));

      const matchesDepartment =
        !dept || dept === "All" || e.department === dept;

      return matchesSearch && matchesDepartment;
    });

    setEmployees(filtered);
    setEmployeesLength(filtered.length || null);
    setCurrentPage(1);
  }, [searchTerm, filterDepartment, allEmployees]);

  const handleRemoveProjects = (projectToRemove) => {
    setFormData({
      ...formData,
      projects: formData.projects.filter(
        (project) => project !== projectToRemove,
      ),
    });
  };

  const handleProjects = (e) => {
    // 2) Enter handler: add to list + clear input

    if (e.key !== "Enter") return;
    e.preventDefault(); // avoid form submit

    const value = (e.target.value || "").trim();
    if (!value) return;

    setFormData((prev) => {
      // avoid duplicates (optional)
      if (prev.projects?.includes(value)) {
        return { ...prev, project: "" }; // just clear input
      }
      return {
        ...prev,
        projects: [...(prev.projects || []), value],
        project: "", // clear the input
      };
    });
  };

  // Build the final soft-skills object to send to API
  const buildFinalSoftSkills = () => {
    const base = formData.softSkills?.benchmarkSkills || {};
    const temp = tempSoftSkills || {};
    const edits = softSkillValues || {};

    // Union of all keys that exist anywhere
    const allKeys = new Set([
      ...Object.keys(base),
      ...Object.keys(temp),
      ...Object.keys(edits),
    ]);

    const clamp010 = (n) => Math.min(10, Math.max(0, n));

    const out = {};
    for (const name of allKeys) {
      // Prefer user edit if it’s a number; else temp; else base
      const raw =
        edits[name] !== "" && edits[name] !== undefined
          ? edits[name]
          : temp[name] !== undefined
            ? temp[name]
            : base[name];

      const n = Number(raw);
      out[name] = Number.isFinite(n) ? clamp010(n) : 0;
    }
    return out;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsCreateLoading(true);
    try {
      const obj = {
        teamName: formData.name,
        department: formData.department,
        teamLead: {
          // userId: formData.lead.userId,
          userId: formData.lead.userId,
          name: formData.lead.name,
        },
        workStyle: formData.workStyle,
        openPositions: formData.openPositions,
        description: formData.description,
        teamCulture: formData.teamCulture,
        members: selectedMembers.map((member) => ({
          // userId: member.userId,
          userId: member._id,
          name: member.name,
        })),
        projects: formData.projects,

        softSkillsRequired: buildFinalSoftSkills(),
        jobSkillsRequired: finalNeededSkills,
      };

      const response = await createTeamApi(obj);
      console.log("Team created successfully:", response);
      if (response.code == 200) {
        setShowModal({
          show: true,
          type: "success",
          title: t("teamCreatePage.teamCreated"),
          showButton: false,
          // message: t("teamCreatePage.teamCreatedMessage", {
          //   teamName: formData.name,
          //   memberCount: selectedMembers.length,
          // }),
          message: t("teamCreatePage.teamCreatedAddMembersMessage", {
            teamName: formData.name,
          }),
        });

        getTeamByIdApiHandler(response.data._id);
        // setTimeout(() => {
        //   onNavigate("/teams");
        // }, 1000);
      }
    } catch (error) {
      handleApiError(error, {
        showModal: true,
        type: "error",
        title: t("teamCreatePage.errorCreatingTeam"),
        message: `${
          error.response?.data?.message ||
          t("teamCreatePage.errorCreatingTeamMessage")
        }`,
      });
      // return;
    } finally {
      setIsCreateLoading(false);
    }
  };

  const handleAddSkill = () => {
    if (newSkill.trim() && !formData.skills.includes(newSkill.trim())) {
      setFormData({
        ...formData,
        skills: [...formData.skills, newSkill.trim()],
      });
      setNewSkill("");
    }
  };

  const handleRemoveSkill = (skillToRemove) => {
    setFormData({
      ...formData,
      skills: formData.skills.filter((skill) => skill !== skillToRemove),
    });
  };
  const handleAddNeededSkill = () => {
    const skillsToAdd = (newNeededSkill || "")
      .split(",")
      .map((skill) => skill.trim())
      .filter(Boolean);
    if (!skillsToAdd.length) return;

    setTempJobSkills((prev) => {
      const lower = prev.map((x) => x.toLowerCase());
      const next = [...prev];

      skillsToAdd.forEach((skill) => {
        const key = skill.toLowerCase();
        if (!lower.includes(key)) {
          lower.push(key);
          next.push(skill);
        }
      });

      return next;
    });

    // allow it back if it was previously removed
    setRemovedJobSkills((prev) =>
      prev.filter(
        (x) => !skillsToAdd.some((skill) => x === skill.toLowerCase()),
      ),
    );

    setNewNeededSkill("");
  };

  // const handleAddNeededSkill = () => {
  //   if (
  //     newNeededSkill.trim() &&
  //     !formData.neededSkills.includes(newNeededSkill.trim())
  //   ) {
  //     setFormData({
  //       ...formData,
  //       neededSkills: [...formData.neededSkills, newNeededSkill.trim()],
  //     });
  //     // add the needed job skills to the temporary state
  //     setTempJobSkills((prev) => [...prev, newNeededSkill.trim()]);
  //     console.log("Temporary job skills updated:", tempJobSkills);
  //     setNewNeededSkill("");
  //   }
  // };

  // const combinedJobSkills = useMemo(() => {
  //   const map = new Map(); // key(lowercased) -> { label, fromUser, fromApi }
  //   const add = (list, from) => {
  //     list.forEach((s) => {
  //       const raw = String(s || "").trim();
  //       if (!raw) return;
  //       const key = raw.toLowerCase();
  //       if (!map.has(key))
  //         map.set(key, { label: raw, fromUser: false, fromApi: false });
  //       const entry = map.get(key);
  //       entry[from] = true;
  //       // prefer user's exact casing/label if present
  //       if (from === "fromUser") entry.label = raw;
  //     });
  //   };
  //   add(apiJobSkills, "fromApi");
  //   add(tempJobSkills, "fromUser");
  //   return Array.from(map.values()); // [{label, fromUser, fromApi}]
  // }, [apiJobSkills, tempJobSkills]);
  const combinedJobSkills = useMemo(() => {
    const removed = new Set(removedJobSkills.map((s) => s.toLowerCase()));
    const map = new Map(); // key -> { label, fromUser, fromApi }

    const add = (list, from) => {
      (list || []).forEach((raw) => {
        const label = String(raw || "").trim();
        if (!label) return;
        const key = label.toLowerCase();
        if (removed.has(key)) return; // 👈 ignore removed
        if (!map.has(key))
          map.set(key, { label, fromUser: false, fromApi: false });
        const entry = map.get(key);
        entry[from] = true;
        if (from === "fromUser") entry.label = label; // prefer user casing
      });
    };

    add(apiJobSkills, "fromApi");
    add(tempJobSkills, "fromUser");
    return Array.from(map.values());
  }, [apiJobSkills, tempJobSkills, removedJobSkills]);

  // Final needed skills array
  const finalNeededSkills = useMemo(
    () => combinedJobSkills.map((s) => s.label),
    [combinedJobSkills],
  );
  const handleRemoveNeededSkill = (skillToRemove) => {
    const key = String(skillToRemove || "")
      .trim()
      .toLowerCase();
    if (!key) return;

    // remove from both sources
    setTempJobSkills((prev) => prev.filter((s) => s.toLowerCase() !== key));
    setApiJobSkills((prev) => prev.filter((s) => s.toLowerCase() !== key));

    // remember removal so re-fetches don't bring it back
    setRemovedJobSkills((prev) => (prev.includes(key) ? prev : [...prev, key]));
  };

  const handleAddPositionType = () => {
    if (
      newPositionType.trim() &&
      !formData.openPositionTypes.includes(newPositionType.trim())
    ) {
      setFormData({
        ...formData,
        openPositionTypes: [
          ...formData.openPositionTypes,
          newPositionType.trim(),
        ],
      });
      setNewPositionType("");
    }
  };

  const handlePositionTypeChange = (index, value) => {
    const newPositionTypes = [...formData.openPositionTypes];
    newPositionTypes[index] = value;
    setFormData({
      ...formData,
      openPositionTypes: newPositionTypes,
    });
  };

  const handleRemoveOpenPositionType = (index) => {
    const newPositionTypes = formData.openPositionTypes.filter(
      (_, i) => i !== index,
    );
    setFormData({
      ...formData,
      openPositionTypes: newPositionTypes,
      openPositions: Math.max(0, formData.openPositions - 1),
    });
  };

  // Update position types array when open positions number changes
  useEffect(() => {
    const currentLength = formData.openPositionTypes.length;
    const targetLength = formData.openPositions;

    if (targetLength > currentLength) {
      // Add empty strings for new positions
      const newPositionTypes = [
        ...formData.openPositionTypes,
        ...Array(targetLength - currentLength).fill(""),
      ];
      setFormData((prev) => ({
        ...prev,
        openPositionTypes: newPositionTypes,
      }));
    } else if (targetLength < currentLength) {
      // Remove excess position types
      const newPositionTypes = formData.openPositionTypes.slice(
        0,
        targetLength,
      );
      setFormData((prev) => ({
        ...prev,
        openPositionTypes: newPositionTypes,
      }));
    }
  }, [formData.openPositions]);

  // const disableSkillsbtn = async () => {
  //   // disable the next button if the formdata is invalid
  //   const hasSkills = formData.skills.length > 0;
  //   return hasSkills;
  // };
  const [isMemberSelected, setIsMemberSelected] = useState([]);

  const handleAddMember = (employee) => {
    setSelectedMembers([...selectedMembers, employee]);

    setIsMemberSelected((prev) => [...prev, employee._id]);
    // Auto-add skills from the new member
    const newSkills = employee.skills.filter(
      (skill) =>
        !formData.skills.some(
          (existingSkill) =>
            existingSkill.toLowerCase() === skill.toLowerCase(),
        ),
    );

    if (newSkills.length > 0) {
      setFormData((prev) => ({
        ...prev,
        skills: [...prev.skills, ...newSkills],
      }));
    }
  };

  const handleRemoveMember = (employeeId) => {
    console.log("Removing member with ID:", employeeId);
    // Remove from selected members
    setSelectedMembers(
      selectedMembers.filter((member) => member._id !== employeeId),
    );
    setIsMemberSelected((prev) => prev.filter((id) => id !== employeeId));
  };

  const handleModalClose = () => {
    setShowModal({ show: false, type: "", title: "", message: "" });
    if (showModal.type === "success") {
      // onNavigate("/teams");
    }
  };

  const getPerformanceColor = (performance) => {
    if (performance >= 90) return "performance-excellent";
    if (performance >= 80) return "performance-good";
    return "performance-average";
  };

  // Handlers for soft skills
  // const handleSoftSkillValueChange = (skillName, value) => {
  //   setSoftSkillValues((prev) => ({
  //     ...prev,
  //     [skillName]: parseInt(value) || 0,
  //   }));
  // };
  // const handleSoftSkillValueChange = (skillName, value) => {
  //   const n = value === "" ? "" : Number(value);
  //   if (value === "" || (!Number.isNaN(n) && n >= 0 && n <= 10)) {
  //     setSoftSkillValues((prev) => ({ ...prev, [skillName]: n }));
  //     setTempSoftSkills((prev) => ({ ...prev, [skillName]: n }));
  //   }
  // };

  const handleSoftSkillValueChange = (skillName, value) => {
    const n = value === "" ? "" : Number(value);
    if (value === "" || (!Number.isNaN(n) && n >= 0 && n <= 10)) {
      setSoftSkillValues((prev) => {
        const next = { ...prev };
        next[skillName] = n;
        return next;
      });
      setTempSoftSkills((prev) => {
        const next = { ...prev };
        next[skillName] = n;
        return next;
      });
    }
  };

  // useEffect(() => {
  //   if (formData.softSkills?.skillsFound) {
  //     setSoftSkillValues(formData.softSkills.skillsFound);
  //   }
  // }, [formData.softSkills?.skillsFound]);

  const handleEditSoftSkill = (skillName, value) => {
    setEditingSoftSkill({ skillName, originalValue: value });
  };

  const handleSaveSoftSkill = () => {
    setEditingSoftSkill(null);
    console.log("Soft skill values saved:", softSkillValues);
  };

  const handleCancelEditSoftSkill = () => {
    if (editingSoftSkill) {
      setSoftSkillValues((prev) => ({
        ...prev,
        [editingSoftSkill.skillName]: editingSoftSkill.originalValue,
      }));
    }
    setEditingSoftSkill(null);
  };

  // Handlers for job skills
  const handleRemoveJobSkill = (skillToRemove) => {
    const updatedSkills = formData.hardSkills.skillsFound.filter(
      (skill) => skill !== skillToRemove,
    );
    setFormData((prev) => ({
      ...prev,
      hardSkills: {
        ...prev.hardSkills,
        skillsFound: updatedSkills,
      },
    }));
    if (showJobSkillListModal.visible && showJobSkillListModal.removable) {
      setShowJobSkillListModal((prev) => ({
        ...prev,
        skills: updatedSkills,
      }));
    }
    console.log("Job skill removed:", skillToRemove);
  };

  // UPDATE TEAM DETAILS
  const handleUpdate = async () => {
    setIsUpdateLoading(true);

    try {
      let obj = {
        teamId: paramId,
        teamName: formData.name,
        department: formData.department,
        teamLead: formData.lead,
        description: formData.description,
        workStyle: formData.workStyle,
        openPositions: formData.openPositions,
        teamCulture: formData.teamCulture,
        projects: formData.projects,
        members: selectedMembers.map((mem) => {
          return {
            // userId: mem.userId,
            userId: mem._id,
            name: mem.name,
          };
        }),
        // neededSkills: formData.neededSkills,
        // softSkillsRequired: {
        //   ...softSkillValues, // Ensure updated soft skill values are sent
        // },
        softSkillsRequired: buildFinalSoftSkills(),
        jobSkillsRequired: finalNeededSkills, // Use the final needed skills array
        // jobSkillsRequired: formData.neededSkills, // Assuming hard skills are updated via remove handler directly
        // projects: formData.projects,
      };
      console.log("Update Team Object:", obj);
      const response = await updateTeamApi(obj);
      if (response.code === 200) {
        setShowModal({
          show: true,
          type: "success",
          title: t("teamCreatePage.teamUpdated"),
          message: t("teamCreatePage.teamUpdatedMessage", {
            teamName: formData.name,
          }),
        });
        // setTimeout(() => {
        navigate(`/teams/${paramId}`);
        // }, 1000);
      }
    } catch (error) {
      handleApiError(error, {
        showModal: true,
        showButton: false,
      });
    } finally {
      setIsUpdateLoading(false);
    }
  };

  // Helper to render skill sections with optional "more" button and modal
  const renderSkillSection = ({
    title,
    skills,
    type,
    limit = 10,
    isEditable = true,
    isRemovable = false,
  }) => {
    const displayedSkills = skills;
    const remainingCount = skills.length - limit;

    const openModal = () => {
      if (type === "soft") {
        const softSkillsWithValues = skills.map((skillName) => ({
          name: skillName,
          value:
            softSkillValues[skillName] !== undefined
              ? softSkillValues[skillName]
              : t("teamCreatePage.notAvailableShort"),
        }));
        setShowSoftSkillListModal({
          visible: true,
          title: t("teamCreatePage.allTitle", {
            title,
          }),
          skills: softSkillsWithValues,
          type: "soft",
        });
      } else {
        setShowJobSkillListModal({
          visible: true,
          title: t("teamCreatePage.allTitle", {
            title,
          }),
          skills: skills,
          type: "job",
          removable: isRemovable,
        });
      }
    };

    return (
      <div className="skill-section-container">
        <h4>
          {title} ({skills.length})
        </h4>
        <div
          className={type === "soft" ? "soft-skills-grid" : "job-skills-list"}
        >
          {displayedSkills.length === 0 ? (
            <span className="no-skills-message">
              {" "}
              {t("teamCreatePage.noSkillsFound")}
            </span>
          ) : (
            displayedSkills.map((skill, index) => {
              if (type === "soft") {
                const skillName = skill;
                const value = softSkillValues[skillName];
                return (
                  <div key={index} className="soft-skill-item">
                    <div className="soft-skill-info">
                      <span className="soft-skill-name">{skillName}:</span>
                      {isEditable &&
                      editingSoftSkill?.skillName === skillName ? (
                        <div className="soft-skill-value-edit">
                          <input
                            type="number"
                            value={value}
                            onChange={(e) =>
                              handleSoftSkillValueChange(
                                skillName,
                                e.target.value,
                              )
                            }
                            onBlur={handleSaveSoftSkill}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") handleSaveSoftSkill();
                              if (e.key === "Escape")
                                handleCancelEditSoftSkill();
                            }}
                          />
                          <div className="soft-skill-edit-actions">
                            <button
                              onClick={handleSaveSoftSkill}
                              className="soft-skill-save-btn"
                            >
                              Save
                            </button>
                            <button
                              onClick={handleCancelEditSoftSkill}
                              className="soft-skill-cancel-btn"
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      ) : (
                        <div className="soft-skill-display">
                          <span className="soft-skill-value">
                            {value !== undefined
                              ? value
                              : t("teamCreatePage.notAvailableShort")}
                          </span>
                          {isEditable && (
                            <button
                              onClick={() =>
                                handleEditSoftSkill(skillName, value)
                              }
                              className="soft-skill-edit-btn"
                            >
                              <Pencil size={14} />
                            </button>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                );
              } else {
                // type === 'job'
                return (
                  <div key={index} className="job-skill-card">
                    <span>{skill}</span>
                    {isRemovable && (
                      <button
                        onClick={() => handleRemoveJobSkill(skill)}
                        className="job-skill-remove-btn"
                      >
                        <X size={14} />
                      </button>
                    )}
                  </div>
                );
              }
            })
          )}
          {remainingCount > 0 && (
            <button onClick={openModal} className="view-more-skills-btn">
              +{remainingCount} more
            </button>
          )}
        </div>
      </div>
    );
  };

  // Function to go to next tab
  // const handleNextTab = () => {
  //   if (activeTab === "basic") {
  //     getSkillsByTeamDescApiHandler(formData);
  //   } else if (activeTab === "members") {
  //     setActiveTab("members");
  //     handleUpdate();
  //   }
  // };
  const handleNextTab = () => {
    if (activeTab === "basic") {
      handleTabClick("skills");
      // getSkillsByTeamDescApiHandler(formData);
    } else if (activeTab === "members") {
      setActiveTab("members");
      handleUpdate(); // sets isUpdateLoading internally
    }
  };

  const handleTabClick = (tab) => {
    if (tab == "basic") {
      setActiveTab(tab);
    } else if (tab == "skills") {
      // check the team information form is valid
      if (
        !formData.name ||
        !formData.department ||
        !formData.description ||
        !formData.teamCulture ||
        !formData.lead.userId
      ) {
        console.log("Tab clicked", tab);

        setShowModal({
          show: true,
          type: "error",
          title: t("teamCreatePage.validation.invalidFormTitle"),
          message: t("teamCreatePage.validation.fillRequiredFields"),
          showButton: false,
        });
        // return;
      } else {
        // setActiveTab(tab);
        getSkillsByTeamDescApiHandler(formData);
      }
    } else if (tab === "members") {
      console.log("Tab clicked", tab);
      // check the team members form is valid
      if (buildFinalSoftSkills.length === 0) {
        setShowModal({
          show: true,
          type: "error",
          title: t("teamCreatePage.validation.invalidTitle"),
          message: t("teamCreatePage.validation.saveTeamBeforeAddingMembers"),
          showButton: false,
        });
      }
    }
  };
  const [isNextLoading, setIsNextLoading] = useState(false); // for Next (basic → skills)
  const [isUpdateLoading, setIsUpdateLoading] = useState(false); // for Next on members tab (update)
  const [isCreateLoading, setIsCreateLoading] = useState(false); // for Create Team
  return (
    <div className="team-create-page">
      <button
        className="nav-back"
        onClick={() => window.history.back()}
        style={{
          position: "absolute",
          top: "100px",
          left: "20px",
          color: "#333",
        }}
      >
        <ArrowLeft size={16} />
        {t("common.back")}
      </button>

      <main className="team-create-main">
        <div className="container">
          <div className="page-header">
            <div className="header-icon">
              <Users size={32} />
            </div>
            <h1>{t("teamCreatePage.pageTitle")}</h1>
            <p>{t("teamCreatePage.pageDescription")}</p>
          </div>

          {/* Tab Navigation */}
          <div className="tab-navigation">
            {/* TEAM INFO */}
            <button
              disabled={activeTab === "members"}
              className={`tab-btn ${activeTab === "basic" ? "active" : ""}`}
              onClick={() => handleTabClick("basic")}
            >
              <Settings size={16} />

              {t("teamCreatePage.basicInfo")}
            </button>
            {/* SKILLS */}
            <button
              disabled={activeTab === "members"}
              // disabled={disableSkillsbtn}
              className={`tab-btn ${activeTab === "skills" ? "active" : ""}`}
              onClick={() => handleTabClick("skills")}
            >
              {/* <Target size={16} /> */}

              {(activeTab === "basic" && isNextLoading) ||
              (activeTab === "members" && isUpdateLoading) ? (
                <>
                  <Loader2 size={16} className="spin" />
                </>
              ) : (
                <>
                  <Target size={16} />
                </>
              )}
              {t("teamCreatePage.skillsRequirements")}
            </button>
            {/* MEMBERS */}
            <button
              className={`tab-btn ${activeTab === "members" ? "active" : ""}`}
              onClick={() => handleTabClick("members")}
            >
              <Users size={16} />
              {t("teamCreatePage.addMembers")}
            </button>
          </div>

          <form className="team-create-form">
            {activeTab === "basic" && (
              <div className="form-section">
                <h2>
                  <Settings size={20} />
                  {t("teamCreatePage.basicInformation")}
                </h2>

                <div className="form-grid">
                  <div className="form-group">
                    <label>
                      {t("teamCreatePage.teamName")}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      value={formData.name}
                      // onChange={(e) => {
                      //   setFormData({ ...formData, name: e.target.value });
                      //   getTeamLeadNamesApiHandler(e);
                      // }}

                      onChange={onTeamNameChange}
                      required
                      placeholder={t("teamCreatePage.enterTeamName")}
                    />
                  </div>

                  <div className="form-group">
                    <label>
                      {t("common.department")}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <select
                      value={formData.department}
                      onChange={(e) => {
                        if (e.target.value === "__add__") {
                          navigate("/settings/organization-info");
                          return;
                        }
                        setFormData({
                          ...formData,
                          department: e.target.value,
                        });
                      }}
                      required
                    >
                      {departments.length === 0 ? (
                        <>
                          <option value="">
                            {t("teamCreatePage.noDepartmentsAvailable")}
                          </option>
                          <option value="__add__">
                            {t("teamCreatePage.createDepartment")}
                          </option>
                        </>
                      ) : (
                        <>
                          <option value="">
                            {t("teamCreatePage.selectDepartment")}
                          </option>
                          {departments.map((dept) => (
                            <option key={dept._id} value={dept.name}>
                              {dept.name}
                            </option>
                          ))}
                        </>
                      )}
                    </select>
                  </div>

                  <div className="form-group">
                    <label>
                      {t("teamCreatePage.teamLead")}
                      <span style={{ color: "red" }}>*</span>
                    </label>

                    <div className="select-with-loader">
                      <select
                        placeholder={t("teamCreatePage.selectTeamLead")}
                        value={formData.lead._id}
                        onChange={(e) => {
                          const selectedLead = teamLead.find(
                            (lead) => lead.id === e.target.value,
                          );
                          setFormData({
                            ...formData,
                            lead: selectedLead
                              ? {
                                  userId: selectedLead.id,
                                  name: selectedLead.name,
                                }
                              : { userId: "", name: "" },
                          });
                        }}
                        required
                        disabled={isTeamLeadLoading} // prevent selection while fetching
                      >
                        <option value="">
                          {isTeamLeadLoading
                            ? t("teamCreatePage.loadingTeamLeads")
                            : t("teamCreatePage.selectTeamLead")}
                        </option>

                        {!isTeamLeadLoading &&
                          teamLead.map((lead) => (
                            <option key={lead.id} value={lead.id}>
                              {lead.name}
                            </option>
                          ))}
                      </select>

                      {/* Spinner overlay inside the select */}
                      {isTeamLeadLoading && (
                        <span
                          className="select-loader"
                          aria-hidden="true"
                        ></span>
                      )}
                    </div>
                  </div>

                  <div className="form-group">
                    <label>{t("teamCreatePage.workStyle")}</label>
                    <select
                      value={formData.workStyle}
                      onChange={(e) =>
                        setFormData({ ...formData, workStyle: e.target.value })
                      }
                    >
                      <option value="">{t("common.selectWorkStyle")}</option>
                      {workStyles.map((style) => (
                        <option key={style} value={style}>
                          {t(
                            `teamCreatePage.workStyles.${style
                              .toLowerCase()
                              .replace("-", "")}`,
                          )}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div className="form-group">
                    <label>{t("teamCreatePage.projects")}</label>
                    <input
                      type="text"
                      value={formData.project}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          project: e.target.value,
                        }))
                      }
                      onKeyDown={handleProjects}
                      placeholder={t("teamCreatePage.enterProjectName")}
                    />

                    {formData.projects.length > 0 && (
                      <div className="skills-tags">
                        {formData.projects.length === 0 ? (
                          <span className="no-skills-message">
                            {t("teamCreatePage.noProjects")}
                          </span>
                        ) : (
                          formData.projects?.map((project, index) => (
                            <span key={index} className="needed-tag">
                              {project}
                              <button
                                type="button"
                                className="remove-skill"
                                onClick={() => handleRemoveProjects(project)}
                              >
                                <Minus size={12} />
                              </button>
                            </span>
                          ))
                        )}
                      </div>
                    )}
                  </div>
                </div>

                <div className="form-group full-width">
                  <label>
                    {t("teamCreatePage.description")}
                    <span style={{ color: "red" }}>*</span>
                    <CustomTooltip
                      tooltip={{
                        title: t("teamCreatePage.tooltips.descriptionTitle"),
                        message: t(
                          "teamCreatePage.tooltips.descriptionMessage",
                        ),
                      }}
                      id="team-desc-tooltip"
                    >
                      <span
                        style={{
                          marginLeft: 5,
                          cursor: "pointer",
                          position: "relative",
                          top: "3px",
                        }}
                      >
                        <Info size={14} color="#888" />
                      </span>
                    </CustomTooltip>
                  </label>
                  <textarea
                    value={formData.description}
                    onChange={(e) =>
                      setFormData({ ...formData, description: e.target.value })
                    }
                    required
                    placeholder={t("teamCreatePage.enterDescription")}
                    rows={3}
                  />
                </div>

                <div className="form-group full-width">
                  <label>
                    {t("teamCreatePage.teamCulture")}
                    <span style={{ color: "red" }}>*</span>
                    <CustomTooltip
                      tooltip={{
                        title: t("teamCreatePage.tooltips.cultureTitle"),
                        message: t("teamCreatePage.tooltips.cultureMessage"),
                      }}
                      id="team-desc-tooltip"
                    >
                      <span
                        style={{
                          marginLeft: 5,
                          cursor: "pointer",
                          position: "relative",
                          top: "3px",
                        }}
                      >
                        <Info size={14} color="#888" />
                      </span>
                    </CustomTooltip>
                  </label>
                  <textarea
                    value={formData.teamCulture}
                    onChange={(e) =>
                      setFormData({ ...formData, teamCulture: e.target.value })
                    }
                    placeholder={t("teamCreatePage.enterTeamCulture")}
                    rows={2}
                  />
                </div>

                {/* Next Button for Basic Tab */}
              </div>
            )}

            {activeTab === "members" && (
              <div className="form-section">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #ccc",
                    paddingBottom: "10px",
                  }}
                >
                  <p style={{ fontSize: "2rem", fontWeight: "600" }}>
                    {t("teamCreatePage.addTeamMembers")}
                  </p>
                  <button
                    onClick={handleUpdate}
                    disabled={selectedMembers.length === 0}
                    type="button"
                    style={{ height: "2.5rem" }}
                    className="btn btn-primary"
                  >
                    {activeTab === "members" && isUpdateLoading ? (
                      <>
                        <Loader2 size={16} className="spin" />
                        {activeTab === "members"
                          ? t("teamCreatePage.addingMembers")
                          : t("common.loading")}
                      </>
                    ) : (
                      t("teamCreatePage.addMembers")
                    )}
                  </button>
                </div>
                {/* <h2>
                  <Users size={20} />
                  {t("teamCreatePage.addTeamMembers")}
                  <p>Add Members</p>
                </h2> */}

                {/* New section for Open Positions */}
                {/* <div className="open-positions-note"> */}
                {/* <p>
                    First, add members to your team. After that, you can specify
                    the number and types of open positions.
                  </p> */}
                {/* <div className="form-group">
                    <label>{t("teamCreatePage.openPositions")}</label>
                    <div className="number-input">
                      <button
                        type="button"
                        className="number-btn"
                        onClick={() =>
                          setFormData({
                            ...formData,
                            openPositions: Math.max(
                              0,
                              formData.openPositions - 1
                            ),
                          })
                        }
                      >
                        <Minus size={16} />
                      </button>
                      <input
                        type="number"
                        value={formData.openPositions}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            openPositions: Number.parseInt(e.target.value) || 0,
                          })
                        }
                        min="0"
                        className="number-field"
                      />
                      <button
                        type="button"
                        className="number-btn"
                        onClick={() =>
                          setFormData({
                            ...formData,
                            openPositions: formData.openPositions + 1,
                          })
                        }
                      >
                        <Plus size={16} />
                      </button>
                    </div>
                  </div> */}

                {/* {formData.openPositions > 0 && (
                    <div className="form-group full-width">
                      <label>Open Position Types</label>
                      <div className="position-input-section">
                        {formData.openPositionTypes.map((position, index) => (
                          <div key={index} className="position-input-group">
                            <select
                              value={position}
                              onChange={(e) =>
                                handlePositionTypeChange(index, e.target.value)
                              }
                              className="position-select"
                            >
                              <option value="">Select position type</option>
                              {commonPositionTypes.map((pos) => (
                                <option key={pos} value={pos}>
                                  {pos}
                                </option>
                              ))}
                            </select>
                            <input
                              type="text"
                              value={position}
                              onChange={(e) =>
                                handlePositionTypeChange(index, e.target.value)
                              }
                              placeholder="Or enter custom position..."
                            />
                            <button
                              type="button"
                              className="remove-position"
                              onClick={() =>
                                handleRemoveOpenPositionType(index)
                              }
                            >
                              <Minus size={12} />
                            </button>
                          </div>
                        ))}
                      </div>
                    </div>
                  )} */}
                {/* </div> */}

                {/* Selected Members */}
                {selectedMembers.length > 0 && (
                  <div className="selected-members">
                    <h3>
                      {t("teamCreatePage.selectedMembers", {
                        count: selectedMembers.length,
                      })}
                    </h3>
                    <div className="selected-members-grid">
                      {selectedMembers.map((member) => (
                        <div key={member.id} className="selected-member-card">
                          <div className="member-info">
                            <div className="member-avatar">
                              <User size={16} />
                            </div>
                            <div>
                              <h4>{member.name}</h4>
                              <p>{member.role}</p>
                            </div>
                          </div>
                          <button
                            type="button"
                            className="remove-member-btn"
                            onClick={() => handleRemoveMember(member._id)}
                            title={t("teamCreatePage.removeFromTeam")}
                          >
                            <Minus size={16} />
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Available Employees */}
                <div className="available-employees">
                  <h3 style={{ marginTop: "1rem" }}>
                    {t("teamCreatePage.availableEmployees")}
                  </h3>

                  <div className="employee-filters">
                    <div className="search-container">
                      <Search size={20} className="search-icon" />
                      <input
                        type="text"
                        placeholder={t("teamCreatePage.searchEmployees")}
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        // onChange={handleFiltersInMembers}
                        className="search-input"
                      />
                    </div>

                    <div className="ufilter-group">
                      <Filter size={16} />
                      <label>{t("common.department")}:</label>
                      <select
                        value={filterDepartment}
                        onChange={(e) => {
                          if (e.target.value === "__add__") {
                            navigate("/settings/organization-info");
                            return;
                          }
                          setFilterDepartment(e.target.value);
                          // handleFiltersInMembers();
                        }}
                        className="ufilter-select"
                      >
                        {departments.length === 0 ? (
                          <>
                            <option value="">
                              {t("teamCreatePage.noDepartmentsAvailable")}
                            </option>
                            <option value="__add__">
                              {t("teamCreatePage.createDepartment")}
                            </option>
                          </>
                        ) : (
                          <>
                            <option value="">
                              {t("teamCreatePage.selectDepartment")}
                            </option>
                            {departments.map((dept) => (
                              <option key={dept._id} value={dept.name}>
                                {dept.name}
                              </option>
                            ))}
                          </>
                        )}
                      </select>
                    </div>
                  </div>

                  {paginatedEmployees.length == 0 ? (
                    <NoDataFound />
                  ) : (
                    <div className="candidates-grid">
                      {paginatedEmployees.map((employee) => (
                        <div key={employee?._id} className="candidate-card">
                          <div className="ccandidate-header">
                            <div className="ccandidate-info">
                              <div className="ccandidate-avatar">
                                <User size={16} />
                              </div>
                              <div>
                                <h4>{employee?.name}</h4>
                                <p>{employee?.designation}</p>
                                <p className="ccandidate-department">
                                  {employee?.department}
                                </p>
                              </div>
                            </div>
                            <button
                              type="button"
                              className="add-btn"
                              onClick={() => handleAddMember(employee)}
                              title={t("teamCreatePage.addToTeam")}
                              disabled={isMemberSelected.includes(employee._id)}
                            >
                              {isMemberSelected.includes(employee._id) ? (
                                <>
                                  <Check size={16} />
                                </>
                              ) : (
                                <>
                                  <Plus size={16} />
                                </>
                              )}
                            </button>
                          </div>

                          <div className="candidate-details">
                            <div className="detail-row">
                              <div
                                className={`c-performance-score ${getPerformanceColor(
                                  employee?.teamFit,
                                )}`}
                              >
                                {t("teamCreatePage.teamFit")}{" "}
                                {employee?.teamFit}%
                              </div>
                            </div>
                            <div className="candidate-skills">
                              <h5>{t("teamCreatePage.skills")}:</h5>
                              <div className="skills-tags">
                                {(employee?.skills || [])
                                  .slice(0, 5)
                                  .map((skill, index) => (
                                    <span
                                      key={index}
                                      className="skill-tag small"
                                    >
                                      {typeof skill === "string"
                                        ? skill
                                        : skill?.name}
                                    </span>
                                  ))}

                                {(employee?.skills?.length || 0) > 5 && (
                                  <button
                                    type="button"
                                    className="view-more-skills-btn"
                                    onClick={() =>
                                      openViewMore(
                                        t("teamCreatePage.allSkillsFor", {
                                          name: employee?.name,
                                        }),
                                        employee.skills,
                                      )
                                    }
                                    style={{ fontSize: "12px" }}
                                  >
                                    {t("teamCreatePage.moreCount", {
                                      count: employee.skills.length - 5,
                                    })}
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                  {/* </div> */}
                  {/* Pagination */}
                  {employeesLength && (
                    <div className="pagination-container">
                      <div className="pagination-info">
                        {t("employees.pagination.showing")}{" "}
                        {indexOfFirstItem + 1} {t("employees.pagination.to")}{" "}
                        {Math.min(indexOfLastItem, employees.length)}{" "}
                        {t("employees.pagination.of")} {employeesLength}{" "}
                        {t("employees.pagination.employees")}
                      </div>
                      <div className="pagination-controls">
                        <button
                          type="button"
                          className="pagination-btn"
                          onClick={handlePrevPage}
                          disabled={currentPage === 1}
                        >
                          <ChevronLeft />
                        </button>
                        {Array.from(
                          { length: totalPages },
                          (_, i) => i + 1,
                        ).map((pageNumber) => (
                          <button
                            type="button"
                            key={pageNumber}
                            className={`pagination-btn ${
                              currentPage === pageNumber ? "active" : ""
                            }`}
                            onClick={() => handlePageChange(pageNumber)}
                          >
                            {pageNumber}
                          </button>
                        ))}
                        <button
                          type="button"
                          className="pagination-btn"
                          onClick={handleNextPage}
                          disabled={currentPage === employeesLength}
                        >
                          <ChevronRight />
                        </button>
                      </div>
                    </div>
                  )}
                </div>

                {/* Next Button for Members Tab */}
              </div>
            )}

            {activeTab === "skills" && (
              <div className="form-section">
                <h2>
                  <Target size={20} />
                  {t("teamCreatePage.skillsRequirements")}
                </h2>

                {/* General Team Skills */}
                {/* <div className="skill-section-container">
                  <h4>
                    Current Team Skills ({formData.skills.length})
                  </h4>
                  <div className="skill-input-group">
                    <input
                      type="text"
                      value={newSkill}
                      onChange={(e) => setNewSkill(e.target.value)}
                      placeholder="Add a team skill..."
                      onKeyPress={(e) =>
                        e.key === "Enter" &&
                        (e.preventDefault(), handleAddSkill())
                      }
                    />
                    <button
                      type="button"
                      className="btn btn-sm btn-primary"
                      onClick={handleAddSkill}
                    >
                      <Plus size={14} />
                      Add
                    </button>
                  </div>
                  <div className="skills-tags">
                    {formData.skills.length === 0 ? (
                      <span className="no-skills-message">
                         {t("teamCreatePage.noSkillsFound")}
                      </span>
                    ) : (
                      formData.skills.map((skill, index) => (
                        <span key={index} className="skill-tag">
                          {skill}
                          <button
                            type="button"
                            className="remove-skill"
                            onClick={() => handleRemoveSkill(skill)}
                          >
                            <Minus size={12} />
                          </button>
                        </span>
                      ))
                    )}
                  </div>
                </div> */}

                {/* Soft Skills Section */}
                <div className="skill-gaps-section">
                  <h4>{t("teamCreatePage.requiredSoftSkills")}</h4>

                  {Object.keys(merged).length === 0 ? (
                    <span className="no-skills-message">
                      {t(
                        "teamCreatePage.addDescriptionAndCultureForSoftSkills",
                      )}
                    </span>
                  ) : (
                    <div className="soft-skills-grid">
                      {Object.keys(merged).map((skill) => (
                        <div key={skill} className="soft-skill-item">
                          <div className="soft-skill-info">
                            <span className="soft-skill-name">{skill}</span>
                            <label
                              className="rating-field"
                              aria-label={t("teamCreatePage.ratingOutOfTen", {
                                skill,
                              })}
                            >
                              <input
                                type="number"
                                min={0}
                                max={10}
                                step={1}
                                inputMode="numeric"
                                className="rating-input"
                                value={
                                  softSkillValues[skill] ??
                                  tempSoftSkills[skill] ??
                                  ""
                                }
                                onChange={(e) =>
                                  handleSoftSkillValueChange(
                                    skill,
                                    e.target.value,
                                  )
                                }
                              />
                              <span className="rating-suffix">/10</span>
                            </label>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Job Skills Section */}
                {/* <div className="skill-gaps-section">
                  <h4>Job Skills</h4>
                  {renderSkillSection({
                    title: "Required Job Skills",
                    skills: formData.hardSkills.skillsRequired || [],
                    type: "job",
                    isRemovable: true,
                  })}
                  {renderSkillSection({
                    title: "Current Job Skills",
                    skills: formData.hardSkills.skillsFound || [],
                    type: "job",
                    isRemovable: true,
                  })}
                  {renderSkillSection({
                    title: "Missing Job Skills",
                    skills: formData.hardSkills.skillsMissing || [],
                    type: "job",
                    isRemovable: true,
                  })}
                </div> */}

                {/* Needed Skills (General) */}
                {/* <div className="skill-section-container">
                  <h4>Required Job Skills ({formData.neededSkills.length})</h4>
                  <div className="skill-input-group">
                    <input
                      type="text"
                      value={newNeededSkill}
                      onChange={(e) => setNewNeededSkill(e.target.value)}
                      placeholder={t("teamCreatePage.addNeededSkill")}
                      onKeyPress={(e) =>
                        e.key === "Enter" &&
                        (e.preventDefault(), handleAddNeededSkill())
                      }
                    />
                    <button
                      type="button"
                      className="btn btn-sm btn-primary"
                      onClick={handleAddNeededSkill}
                    >
                      <Plus size={14} />
                      {t("common.add")}
                    </button>
                  </div>
                  <div className="skills-tags">
                    {formData.neededSkills.length === 0 ? (
                      <span className="no-skills-message">
                         {t("teamCreatePage.noSkillsFound")}
                      </span>
                    ) : (
                      formData.neededSkills.map((skill, index) => (
                        <span key={index} className="needed-tag">
                          {skill}
                          <button
                            type="button"
                            className="remove-skill"
                            onClick={() => handleRemoveNeededSkill(skill)}
                          >
                            <Minus size={12} />
                          </button>
                        </span>
                      ))
                    )}
                  </div>
                </div> */}
                <h4>
                  {t("teamCreatePage.requiredJobSkillsWithCount", {
                    count: combinedJobSkills.length,
                  })}
                </h4>

                <div className="skill-input-group">
                  <input
                    type="text"
                    value={newNeededSkill}
                    onChange={(e) => setNewNeededSkill(e.target.value)}
                    placeholder={t("teamCreatePage.addNeededSkill")}
                    onKeyDown={(e) =>
                      e.key === "Enter" &&
                      (e.preventDefault(), handleAddNeededSkill())
                    }
                  />
                  <button
                    type="button"
                    className="btn btn-sm btn-primary"
                    onClick={handleAddNeededSkill}
                  >
                    <Plus size={14} />
                    {t("common.add")}
                  </button>
                </div>

                <div className="skills-tags">
                  {combinedJobSkills.length === 0 ? (
                    <span className="no-skills-message">
                      {" "}
                      {t("teamCreatePage.noSkillsFound")}
                    </span>
                  ) : (
                    combinedJobSkills.map((item, index) => (
                      <span
                        key={`${item.label}-${index}`}
                        className="needed-tag"
                      >
                        {item.label}
                        {/* Remove only affects user-added items; hide the X for pure-API suggestions if you want */}
                        <button
                          type="button"
                          className="remove-skill"
                          onClick={() => handleRemoveNeededSkill(item.label)}
                          title={t("common.remove")}
                        >
                          <Minus size={12} />
                        </button>
                        {/* Optional: show a tiny badge if this came from API only */}
                        {/* {!item.fromUser && item.fromApi && <em className="badge">suggested</em>} */}
                      </span>
                    ))
                  )}
                </div>
              </div>
            )}

            {/* <div className="form-actions">
              <button
                type="button"
                className="btn btn-outline"
                onClick={() => onNavigate("/teams")}
              >
                {t("common.cancel")}
              </button>

              {activeTab === "skills" ? (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSubmit}
                >
                  <Save size={16} />
                  {t("teamCreatePage.createTeam")}
                </button>
              ) : (
                <>
                  <button
                    // disabled={disableSkillsbtn}
                    type="button"
                    className="btn btn-primary"
                    onClick={handleNextTab}
                  >
                    Next
                    <ChevronRight size={16} />
                  </button>
                </>
              )}
            </div> */}
            <div className="form-actions">
              <button
                type="button"
                className="btn btn-outline"
                onClick={() => onNavigate("/teams")}
                disabled={isNextLoading || isUpdateLoading || isCreateLoading}
              >
                {t("common.cancel")}
              </button>

              {activeTab === "skills" ? (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSubmit}
                  disabled={isCreateLoading}
                >
                  {isCreateLoading ? (
                    <>
                      <Loader2 size={16} className="spin" />
                      {t("common.loading")}
                    </>
                  ) : (
                    <>
                      <Save size={16} />
                      {t("teamCreatePage.createTeam")}
                    </>
                  )}
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleNextTab}
                  disabled={
                    (activeTab === "basic" && isNextLoading) ||
                    (activeTab === "members" && isUpdateLoading)
                  }
                >
                  {(activeTab === "basic" && isNextLoading) ||
                  (activeTab === "members" && isUpdateLoading) ? (
                    <>
                      <Loader2 size={16} className="spin" />
                      {activeTab === "members"
                        ? t("teamCreatePage.addingMembers")
                        : t("common.loading")}
                    </>
                  ) : (
                    <>
                      {activeTab === "members"
                        ? t("teamCreatePage.addMembers")
                        : t("common.next")}
                      <ChevronRight size={16} />
                    </>
                  )}
                </button>
              )}
            </div>
          </form>
        </div>
      </main>

      {/* Soft Skills List Modal */}
      {showSoftSkillListModal.visible && (
        <SkillListModal
          title={showSoftSkillListModal.title}
          skills={showSoftSkillListModal.skills}
          type="soft"
          onClose={() =>
            setShowSoftSkillListModal({
              visible: false,
              title: "",
              skills: [],
              type: "soft",
            })
          }
        />
      )}

      {/* Job Skills List Modal */}
      {showJobSkillListModal.visible && (
        <SkillListModal
          title={showJobSkillListModal.title}
          skills={showJobSkillListModal.skills}
          type="job"
          onClose={() =>
            setShowJobSkillListModal({
              visible: false,
              title: "",
              skills: [],
              type: "job",
              removable: false,
            })
          }
          onRemoveSkill={
            showJobSkillListModal.removable ? handleRemoveJobSkill : undefined
          }
        />
      )}

      <Modal
        show={showModal.show}
        onClose={handleModalClose}
        type={showModal.type}
        title={showModal.title}
        message={showModal.message}
        showButton={showModal.showButton}
      />
      <ViewMoreModal
        open={vmOpen}
        onClose={() => setVmOpen(false)}
        title={vmTitle}
        skills={vmSkills}
        variant="job-skills" // uses your modal CSS/chips
        type="hard" // treat as simple list; 'soft' shows values if present
      />

      <SubscriptionExpiredModal
        show={showSubscriptionExpired}
        message={subscriptionMessage}
        onRedirect={handleSubscriptionRedirect}
      />
    </div>
  );
};

export default TeamCreatePage;
